<template>
  <!-- 表单标签大小设置
       @author: liuguisheng
       @date: 2019-11-6
   -->
  <div class="setting-item">
    <el-form-item label="标签宽度(cm)">
      <el-input-number v-model.number="labelWidth" 
                       class="setting-label_width"
                       controls-position="right"
                       placeholder="请输入标签宽度"
                       :precision=precision
                       :step=step
                       :min="0" 
                       :max="10"></el-input-number>
    </el-form-item>
  </div>
</template>

<script>

// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入设置项混入文件
import mixSettingData from '@/mixins/common/mix_setting_data.js';

export default {
  mixins: [ mixValueWatch,mixSettingData ],
  computed: {
    /** @name 最大输入文本长度
     *  @description 将 labelWidth 字段映射到当前 labelWidth 计算属性
     *  @return { Object }
     *  @author 王汝鹏
     *  @version 2019-09-25
     */
    ...mapComputed({
      labelWidth: { 
        parent: i => i.styleOption,
        attr: "labelWidth"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/style_setting/SettingLabelWidth.vue